import template from './tc-google-address.html';
import controller from './tc-google-address.controller';

let TcGoogleAddressComponent = {
  restrict: 'E',
  bindings: {
    ngModel: '=', // Two-way binding for the address value
    placeholder: '@?', // Optional placeholder text
    options: '<?', // Optional autocomplete options
    onPlaceSelected: '&?', // Optional callback
    disabled: '<?', // Optional disabled state
    required: '<?', // Optional required state
    class: '@?', // Optional CSS classes
  },
  template,
  controller,
};

export default TcGoogleAddressComponent;




// WEBPACK FOOTER //
// ./client/common/directives/google-address-autocomplete/tc-google-address.component.js